document.addEventListener('DOMContentLoaded', function () {

  const certificate = document.querySelector('.product-certificate');

  if (!certificate) return;

  const drawer = certificate.querySelector('[data-certificate-drawer]');
  const openButton = certificate.querySelector('[data-certificate-open]');
  const closeButtons = certificate.querySelectorAll('[data-certificate-close]');

  const pdfContainer = certificate.querySelector('[data-certificate-pdf]');
  const loading = certificate.querySelector('[data-certificate-loading]');

  const prevButton = certificate.querySelector('[data-pdf-prev]');
  const nextButton = certificate.querySelector('[data-pdf-next]');
  const zoomInButton = certificate.querySelector('[data-pdf-zoom-in]');
  const zoomOutButton = certificate.querySelector('[data-pdf-zoom-out]');

  const pageText = certificate.querySelector('[data-pdf-page]');
  const zoomText = certificate.querySelector('[data-pdf-zoom]');

  const pdfUrl = pdfContainer
    ? pdfContainer.getAttribute('data-pdf-url')
    : '';

  /*
   * IMPORTANT FIX:
   * Shopify product templates almost always have a
   * `transform` (or filter / will-change) somewhere on
   * an ancestor of this block — usually the media
   * gallery / product grid wrapper, for the slider or
   * zoom effect.
   *
   * That transform creates a new "containing block" for
   * any `position: fixed` descendant, so instead of
   * covering the full viewport, the drawer gets trapped
   * inside that ancestor's box — which is why it was
   * rendering squeezed against / overlapping the product
   * thumbnails instead of sliding in from the right edge
   * of the screen.
   *
   * Moving the drawer to be a direct child of <body>
   * guarantees it always positions against the real
   * viewport, no matter what the theme does elsewhere.
   */
  if (drawer && drawer.parentElement !== document.body) {
    document.body.appendChild(drawer);
  }

  let pdfDocument = null;
  let currentPage = 1;
  let totalPages = 1;
  let zoom = 1;
  let pdfLoading = false;


  /* ================================
     LOAD PDF.JS
  ================================= */

  function loadPDFJS(callback) {

    if (window.pdfjsLib) {
      callback();
      return;
    }

    if (pdfLoading) return;

    pdfLoading = true;

    const script = document.createElement('script');

    script.src =
      'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.min.js';

    script.onload = function () {

      pdfLoading = false;

      if (!window.pdfjsLib) {
        showError('PDF viewer could not be loaded.');
        return;
      }

      window.pdfjsLib.GlobalWorkerOptions.workerSrc =
        'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';

      callback();

    };

    script.onerror = function () {

      pdfLoading = false;

      showError(
        'Unable to load the certificate viewer. Please try again.'
      );

    };

    document.head.appendChild(script);
  }


  /* ================================
     ERROR MESSAGE
  ================================= */

  function showError(message) {

    if (!pdfContainer) return;

    pdfContainer.innerHTML = `
      <div class="product-certificate-error">
        <div class="product-certificate-error__icon">!</div>
        <p>${message}</p>
        <a
          href="${pdfUrl}"
          target="_blank"
          rel="noopener"
        >
          Open Certificate
        </a>
      </div>
    `;

    if (loading) {
      loading.style.display = 'none';
    }
  }


  /* ================================
     RENDER PAGE
  ================================= */

  function renderPage(pageNumber) {

    if (!pdfDocument) return;

    pdfDocument.getPage(pageNumber).then(function (page) {

      const viewerWidth =
        pdfContainer.clientWidth || 600;

      const originalViewport =
        page.getViewport({ scale: 1 });

      /*
       * Automatically fit certificate
       * to drawer width.
       */

      const fitScale =
        (viewerWidth - 20) /
        originalViewport.width;

      const finalScale =
        fitScale * zoom;

      const viewport =
        page.getViewport({
          scale: finalScale
        });

      const canvas =
        document.createElement('canvas');

      const context =
        canvas.getContext('2d', {
          alpha: false
        });

      canvas.width = Math.ceil(viewport.width);
      canvas.height = Math.ceil(viewport.height);

      canvas.style.width =
        Math.ceil(viewport.width) + 'px';

      canvas.style.height =
        Math.ceil(viewport.height) + 'px';

      canvas.className =
        'product-certificate-page';

      pdfContainer.innerHTML = '';

      pdfContainer.appendChild(canvas);

      page.render({
        canvasContext: context,
        viewport: viewport
      }).promise.then(function () {

        if (loading) {
          loading.style.display = 'none';
        }

      }).catch(function (error) {

        console.error(
          'PDF page rendering error:',
          error
        );

        showError(
          'Unable to display this certificate.'
        );

      });

      if (pageText) {
        pageText.textContent =
          currentPage + ' / ' + totalPages;
      }

      if (zoomText) {
        zoomText.textContent =
          Math.round(zoom * 100) + '%';
      }

    }).catch(function (error) {

      console.error(
        'PDF page loading error:',
        error
      );

      showError(
        'Unable to load the certificate page.'
      );

    });

  }


  /* ================================
     LOAD PDF
  ================================= */

  function loadPDF() {

    if (!pdfUrl) {

      showError(
        'No certificate PDF was added to this product.'
      );

      return;
    }

    if (!window.pdfjsLib) {

      loadPDFJS(function () {
        loadPDF();
      });

      return;
    }

    if (loading) {
      loading.style.display = 'block';
      loading.textContent =
        'Loading certificate...';
    }

    window.pdfjsLib
      .getDocument({
        url: pdfUrl,
        withCredentials: false
      })
      .promise
      .then(function (pdf) {

        pdfDocument = pdf;

        totalPages = pdf.numPages;

        currentPage = 1;

        zoom = 1;

        renderPage(currentPage);

      })
      .catch(function (error) {

        console.error(
          'Certificate PDF loading error:',
          error
        );

        showError(
          'The certificate could not be displayed.'
        );

      });

  }


  /* ================================
     OPEN DRAWER
  ================================= */

  function openDrawer() {

    drawer.classList.add('is-open');

    drawer.setAttribute(
      'aria-hidden',
      'false'
    );

    document.body.classList.add(
      'product-certificate-drawer-open'
    );

    if (!pdfDocument) {

      /*
       * Give drawer a moment to become visible
       * before calculating PDF dimensions.
       */

      setTimeout(function () {
        loadPDF();
      }, 100);

    } else {

      setTimeout(function () {
        renderPage(currentPage);
      }, 100);

    }

  }


  /* ================================
     CLOSE DRAWER
  ================================= */

  function closeDrawer() {

    drawer.classList.remove('is-open');

    drawer.setAttribute(
      'aria-hidden',
      'true'
    );

    document.body.classList.remove(
      'product-certificate-drawer-open'
    );

  }


  /* ================================
     OPEN BUTTON
  ================================= */

  if (openButton) {

    openButton.addEventListener(
      'click',
      openDrawer
    );

  }


  /* ================================
     CLOSE BUTTON
  ================================= */

  closeButtons.forEach(function (button) {

    button.addEventListener(
      'click',
      closeDrawer
    );

  });


  /* ================================
     PREVIOUS PAGE
  ================================= */

  if (prevButton) {

    prevButton.addEventListener(
      'click',
      function () {

        if (!pdfDocument) return;

        if (currentPage > 1) {

          currentPage--;

          renderPage(currentPage);

        }

      }
    );

  }


  /* ================================
     NEXT PAGE
  ================================= */

  if (nextButton) {

    nextButton.addEventListener(
      'click',
      function () {

        if (!pdfDocument) return;

        if (currentPage < totalPages) {

          currentPage++;

          renderPage(currentPage);

        }

      }
    );

  }


  /* ================================
     ZOOM IN
  ================================= */

  if (zoomInButton) {

    zoomInButton.addEventListener(
      'click',
      function () {

        if (!pdfDocument) return;

        if (zoom < 2.5) {

          zoom += 0.25;

          renderPage(currentPage);

        }

      }
    );

  }


  /* ================================
     ZOOM OUT
  ================================= */

  if (zoomOutButton) {

    zoomOutButton.addEventListener(
      'click',
      function () {

        if (!pdfDocument) return;

        if (zoom > 0.5) {

          zoom -= 0.25;

          renderPage(currentPage);

        }

      }
    );

  }


  /* ================================
     ESC KEY
  ================================= */

  document.addEventListener(
    'keydown',
    function (event) {

      if (
        event.key === 'Escape' &&
        drawer.classList.contains('is-open')
      ) {

        closeDrawer();

      }

    }
  );

});